import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly cookies automatically
});

// ─── In-memory token store (not localStorage — XSS-safe) ──────────────────
// The token is held in module scope so it survives re-renders but is wiped
// on a hard reload (at which point the httpOnly cookie re-authenticates the user).
let _token = null;
export const setAuthToken = (t) => { _token = t; };
export const clearAuthToken = () => { _token = null; };

// Add Bearer token to every request when available (in-memory after login;
// falls back to httpOnly cookie for page-reload sessions).
api.interceptors.request.use((cfg) => {
  if (_token) cfg.headers.Authorization = `Bearer ${_token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      _token = null;
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export default api;
